import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import validator from 'validator';
import { updateStakeHolder } from 'src/services/projectService';
import { AppActions } from 'src/store/AppReducer';
import {
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  InputAdornment,
  ListSubheader
} from '@mui/material';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import SearchIcon from '@mui/icons-material/Search';
import { useAppSelector } from 'src/hooks/hooks';
import MuiPhoneNumber from 'material-ui-phone-number';

export interface StakeholderInformation {
  name: string;
  designation: string;
  email: string;
  contact: string;
  customerId: string;
  segmentId: string;
}

const EditStakeHolder = ({
  toggle,
  getData,
  customerId,
  data,
  segmentId,
  segments,
  setSnackBarOpen,
  setSnackbarSeverity,
  setSnackBarMessage,
}) => {
  const dispatch = useDispatch();
  const TextFieldStyle = {
    paddingTop: 2,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const LabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const selectStyle = {
    width: '94%',
    marginLeft: 15,
    marginTop: 5,
    paddingRight: 15,
    fontSize: '13px'
  };

  const { register, handleSubmit, reset } = useForm<StakeholderInformation>();

  const [nameError, setNameError] = useState('');
  const [designationError, setDesignationError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [contactError, setContactError] = useState('');
  const [openConfirmation, setOpenConfirmation] = useState(false);

  const [stakeholderObj, setStakeholderObj] = useState<any>({
    name: data.name,
    id: data.id,
    designation: data.designation,
    email: data.email,
    contact: data.contactNumber,
    segmentId: segmentId,
    customerId: customerId
  });

  const toggleConfirmation = () => {
    if (openConfirmation) {
      setOpenConfirmation(false);
    }
    if (
      stakeholderObj.name !== '' &&
      stakeholderObj.name.length < 31 &&
      stakeholderObj.designation !== '' &&
      stakeholderObj.designation.length < 31 &&
      stakeholderObj.email !== '' &&
      stakeholderObj.contact !== '' &&
      stakeholderObj.contact.length > 11 &&
      validator.isEmail(stakeholderObj.email) &&
      customer &&
      segment
    ) {
      setNameError('');
      setDesignationError('');
      setEmailError('');
      setContactError('');
      setOpenConfirmation(!openConfirmation);
    } else if (stakeholderObj.name === '') {
      setNameError('Stakeholder name is required.');
    } else if (stakeholderObj.designation === '') {
      setDesignationError('Designation is required.');
    } else if (stakeholderObj.email === '') {
      setEmailError('Email is required.');
    } else if (stakeholderObj.contact === '') {
      setContactError('Contact number is required.');
    }else if (stakeholderObj.contact.trim().length < 12) {
      setContactError('Contact Number must not be less than 10 numbers.');
    } else if (!validator.isEmail(stakeholderObj.email)) {
      setEmailError('Invalid email address.');
    } else if (!segment) {
      setSegmentError('Segment is required.');
    } else if (!customer) {
      setCustomerError('Customer is required.');
    }
  };

  useEffect(() => {
    setStakeholderObj({
      name: data.name,
      id: data.id,
      designation: data.designation,
      email: data.email,
      contact: data.contactNumber,
      segmentId: segmentId,
      customerId: customerId
    });
  }, [customerId, data, segmentId]);

  const { isLoading } = useAppSelector((state) => state.appReducer);

  const onSubmit = () => {
    if (
      stakeholderObj.name !== '' &&
      stakeholderObj.name.trim().length > 0 &&
      stakeholderObj.name.length < 31 &&
      stakeholderObj.designation !== '' &&
      stakeholderObj.designation.length < 31 &&
      stakeholderObj.email !== '' &&
      stakeholderObj.contact !== '' &&
      stakeholderObj.contact.length > 11 &&
      validator.isEmail(stakeholderObj.email) &&
      customer &&
      segment
    ) {
      dispatch(AppActions.showLoader());

      setNameError('');
      setDesignationError('');
      setEmailError('');
      setContactError('');

      const body = {
        name: data.name === stakeholderObj.name ? null : stakeholderObj.name,
        designation:
          data.designation === stakeholderObj.designation
            ? null
            : stakeholderObj.designation,
        email:
          data.email === stakeholderObj.email ? null : stakeholderObj.email,
        contactNumber:
          data.contactNumber === stakeholderObj.contact
            ? null
            : stakeholderObj.contact,
        segmentId: segment,
        customerId: customer,
        newCustomerId: customerId === customer ? null : customer,
        newSegmentId:
          customerId === customer && segmentId === segment ? null : segment,
        id: stakeholderObj.id
      };

      updateStakeHolder(body)
        .then(() => {
          reset();
          setSnackBarMessage('You have updated the stakeholder successfully.');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          getData();
          toggleConfirmation();
          toggle();
          dispatch(AppActions.hideLoader());
        })
        .catch((error) => {
          setSnackBarMessage(error?.request?.response ? error?.request?.response : 'Unable update the stakeholder');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
          toggleConfirmation();
          toggle();
        });
    } else if (stakeholderObj.name === '') {
      setNameError('Stakeholder name is required.');
    } else if (data.name.trim().length < 1) {
      setNameError('Stakeholder name cannot be only spaces');
    } else if (stakeholderObj.designation === '') {
      setDesignationError('Designation is required.');
    } else if (stakeholderObj.email === '') {
      setEmailError('Email is required.');
    } else if (stakeholderObj.contact === '') {
      setContactError('Contact number is required.');
    } else if (!validator.isEmail(stakeholderObj.email)) {
      setEmailError('Invalid email address.');
    } else if (!segment) {
      setSegmentError('Segment is required.');
    } else if (!customer) {
      setCustomerError('Customer is required.');
    }
  };

  const [segmentError, setSegmentError] = useState('');
  const [customerError, setCustomerError] = useState('');
  const [customers, setCustomers] = useState([]);
  const [segment, setSegment] = useState('');
  const [customer, setCustomer] = useState('');

  useEffect(() => {
    setCustomers(segments.filter((seg) => seg.id === segment)[0]?.customers);
  }, [segment, segments, data]);

  useEffect(() => {
    const singleSegment = segments.filter((seg) => segmentId === seg.id)[0];
    setSegment(singleSegment.id);
  }, [segmentId, segments]);

  useEffect(() => {
    const singleSegment = segments.filter((seg) => segment === seg.id)[0];
    setCustomers(singleSegment?.customers);
  }, [segment, segments]);

  useEffect(() => {
    setCustomer(customers?.filter((fil) => fil.id === customerId)[0]?.id);
  }, [customerId, customers]);

  const containsText = (text, searchText) =>
    text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

  const [selectedOption, setSelectedOption] = useState('');
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    setSelectedOption(segmentId);
  }, [segmentId]);

  const displayedOptions = useMemo(
    () =>
      segments.length > 0 &&
      segments?.filter((option) => containsText(option.name, searchText)),
    [searchText, segments]
  );

  const onClose = () => {
    setNameError('');
    setDesignationError('');
    setEmailError('');
    setContactError('');
    setStakeholderObj({
      name: data.name,
      id: data.id,
      designation: data.designation,
      email: data.email,
      contact: data.contactNumber,
      segmentId: segmentId,
      customerId: customerId
    });
    setSegmentError('');
    setCustomerError('');
    setSelectedOption(segmentId);
    const singleSegment = segments.filter((seg) => segmentId === seg.id)[0];
    setCustomers(singleSegment?.customers);
    setCustomer(customers?.filter((fil) => fil.id === customerId)[0]?.id);
    toggle();
  };

  useEffect(() => {
    if(customer) {
      setCustomerError('');
    }
  }, [customer]);

  return (
    <Fragment>
      {' '}
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid item xs={12} sx={{ pt: 3, pb: 1, pl: 2 }}>
          <Typography style={{ fontSize: '15px' }} variant="h3">
            Edit Stakeholder
          </Typography>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Stakeholder Name<span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              id="editStakeholderName"
              name="editStakeholderName"
              size="small"
              inputProps={{ maxLength: 30 }}
              {...register('name', {})}
              style={TextFieldStyle}
              fullWidth
              value={stakeholderObj.name}
              placeholder="Enter Stakeholder Name"
              variant="outlined"
              onChange={(e) => {
                if (e.target.value.length > 30) {
                  setNameError(
                    'Stakeholder name must not exceed 30 characters'
                  );
                } else {
                  setNameError('');
                }
                setStakeholderObj((prev) => ({
                  ...prev,
                  name: e.target.value
                }));
              }}
            />
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {nameError}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Designation<span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              id="editStakeholderDesignation"
              name="editStakeholderDesignation"
              inputProps={{ maxLength: 30 }}
              size="small"
              {...register('designation', {})}
              style={TextFieldStyle}
              fullWidth
              value={stakeholderObj.designation}
              placeholder="Enter Designation"
              variant="outlined"
              onChange={(e) => {
                if (e.target.value.length > 30) {
                  setDesignationError(
                    'Customer name must not exceed 30 characters'
                  );
                } else {
                  setDesignationError('');
                }
                setStakeholderObj((prev) => ({
                  ...prev,
                  designation: e.target.value
                }));
              }}
            />
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {designationError}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Email<span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              id="editStakeholderEmail"
              name="editStakeholderEmail"
              size="small"
              {...register('email', {})}
              style={TextFieldStyle}
              fullWidth
              value={stakeholderObj.email}
              placeholder="Enter Email"
              variant="outlined"
              autoComplete="new-password"
              onChange={(e) => {
/*                if (e.target.value.length > 20) {
                  setEmailError('Email must not exceed 20 characters');
                } else {
                  setEmailError('');
                }*/
                setStakeholderObj((prev) => ({
                  ...prev,
                  email: e.target.value
                }));
              }}
            />
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {emailError}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Contact Number<span style={{ color: 'red' }}>*</span>
            </Typography>
            <MuiPhoneNumber
            id="editStakeholderPhoneNumber"
            defaultCountry={'lk'}
            size="small"
            {...register('contact', {})}
            InputProps={{
              style: { fontSize: '12px', height: '2.25rem' }
            }}
            style={TextFieldStyle}
            fullWidth
            type="text"
            placeholder="Enter Contact Number"
            variant="outlined"
            value={stakeholderObj.contact}
            onChange={(e) => {
              setStakeholderObj((prev) => ({
                ...prev,
                contact: e
              }));
              if (e.length > 11) {
                setContactError('');
              }
            }}
          />
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {contactError}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Segment<span style={{ color: 'red' }}>*</span>
            </Typography>
            <Select
              id="editStakeholderSegmentName"
              MenuProps={{ autoFocus: false }}
              labelId="search-select-label"
              {...register('segmentId', {})}
              style={{
                height: '2.25rem',
                width: '94%',
                marginLeft: 15,
                marginTop: 5,
                paddingRight: 15,
                fontSize: '13px'
              }}
              displayEmpty
              defaultValue=""
              value={selectedOption}
              onChange={(e) => {
                setSelectedOption(e.target.value);
                setSegment(e.target.value);
              }}
              onClose={() => setSearchText('')}
            >
              <ListSubheader>
                <TextField
                  size="small"
                  autoFocus
                  placeholder="Type to search..."
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key !== 'Escape') {
                      // Prevents autoselecting item while typing (default Select behaviour)
                      e.stopPropagation();
                    }
                  }}
                />
              </ListSubheader>
              <MenuItem
                style={{ display: 'none' }}
                selected
                disabled
                value={''}
              >
                Select Segment
              </MenuItem>
              {displayedOptions.length > 0 &&
                displayedOptions?.map((option, i) => (
                  <MenuItem key={i} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
            </Select>
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {segmentError}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Customer <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Select
              id="editStakeholderCustomerName"
              className="select-text"
              size="small"
              fullWidth
              style={selectStyle}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              {...register('customerId', {})}
              defaultValue={''}
              value={customer}
              onChange={(e) => {
                if(e.target.value) {
                  setCustomer(e.target.value);
                  setCustomerError('');
                }
              }}
            >
              <MenuItem
                style={{ display: 'none' }}
                selected
                disabled
                value={''}
              >
                {!segment
                  ? 'Select a segment first'
                  : segment && customers?.length === 0
                  ? 'No customers in this segment'
                  : 'Select customer'}
              </MenuItem>
              {customers?.map((customer) => {
                return <MenuItem value={customer.id}>{customer.name}</MenuItem>;
              })}
            </Select>
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {customerError}
            </Typography>
          </Grid>
          <Grid
            item
            sx={{
              mb: 2,
              mt: 2,
              pr: 2,
              display: 'flex',
              justifyContent: 'flex-end'
            }}
            xs={12}
          >
            <Button
              id="editStakeholder-btn-onClose"
              sx={{
                width: '10%',
                fontWeight: 'normal',
                background: '#F5F7FF',
                fontSize: '13px'
              }}
              onClick={() => onClose()}
            >
              Cancel
            </Button>
            <Button
              id="editStakeholder-btn-onSubmit"
              disabled={stakeholderObj?.name === '' || isLoading}
              className={isLoading ? 'loading' : ''}
              onClick={() => toggleConfirmation()}
              sx={{
                ml: 2,
                width: '10%',
                fontSize: '13px',
                fontWeight: 'normal',
                background: '#0069E4'
              }}
              variant="contained"
              type="button"
            >
              Update
            </Button>
          </Grid>
        </Grid>
      </form>
      <ConfirmationModal
        isLoading={isLoading}
        open={openConfirmation}
        toggle={toggleConfirmation}
        message={`Are you sure want to update this stakeholder?`}
        onConfirm={() => onSubmit()}
        noToggle={toggleConfirmation}
      />
    </Fragment>
  );
};

export default EditStakeHolder;
